import { useChatSocket } from './useChatSocket';

export function ChatSocket({ config }: any) {
    useChatSocket(config);

    return null;
}
